import React, { useEffect, useState } from 'react';
import { Box, List, ListItem, ListItemIcon, ListItemText, Avatar, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CreateIcon from '@mui/icons-material/Create';
import GroupIcon from '@mui/icons-material/Group';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import QuizIcon from '@mui/icons-material/Quiz';
import Home from '@mui/icons-material/Home';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import RuleIcon from '@mui/icons-material/Rule';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import InsightsIcon from '@mui/icons-material/Insights';
import api from 'lib/api/api';
import { useSelector } from 'react-redux';  // Importing useSelector to get profileName from Redux
import './TeacherNavbar.css'; // Import the CSS file for custom styles

const TeacherNavbar = () => {
    // Get profileName from the Redux store
    const profileName = useSelector((state) => state.auth.user.profileName);
    const teacherProfile = useSelector((state) => state.teacherProfile.profile);
    const displayedName = teacherProfile
        ? `${teacherProfile.firstName || ''} ${teacherProfile.lastName || ''}`.trim()
        : profileName;
    const picture = teacherProfile?.profilePicture;
    const pictureSrc = picture?.startsWith('/api/')
        ? `${process.env.REACT_APP_API_URL}${picture}`
        : picture || '';
    const roleNames = useSelector((state) => state.auth.user.roleNames);  // ✅
    const isManager = roleNames?.includes("TEACHER_MANAGER");
    const [managerPermissions, setManagerPermissions] = useState({});
    useEffect(() => {
        if (!isManager) return;
        api.get('/teacher-manager/permissions')
            .then((response) => setManagerPermissions(response.data || {}))
            .catch(() => setManagerPermissions({}));
    }, [isManager]);

    return (
        <Box className="teacher-navbar">
            {/* Teacher Profile Section */}
            <Box className="teacher-profile" display="flex" flexDirection="column" alignItems="center">
                <Avatar 
                    alt="Teacher Image" 
                    src={pictureSrc}
                    className="teacher-avatar" 
                />
                <Typography variant="h6" className="teacher-name">
                    {displayedName}
                </Typography>
            </Box>

            {/* Navbar Menu */}
            <List className="teacher-menu">
                <ListItem button className="teacher-navbar-item" component={Link} to="/dashboard">
                    <ListItemIcon>
                        <DashboardIcon className="teacher-navbar-icon" />
                    </ListItemIcon>
                    <ListItemText primary="Dashboard" />
                </ListItem>

                <ListItem button className="teacher-navbar-item" component={Link} to="/teacher-profile">
                    <ListItemIcon>
                        <ManageAccountsIcon className="teacher-navbar-icon" />
                    </ListItemIcon>
                    <ListItemText primary="My Profile" />
                </ListItem>

                {/* Create Course Navigation */}
                <ListItem button className="teacher-navbar-item" component={Link} to="/create-course">
                    <ListItemIcon>
                        <CreateIcon className="teacher-navbar-icon" />
                    </ListItemIcon>
                    <ListItemText primary="Create Course" />
                </ListItem>

                <ListItem button className="teacher-navbar-item"component={Link} to="/approval-status">
                    <ListItemIcon>
                        <CheckCircleIcon className="teacher-navbar-icon" />
                    </ListItemIcon>
                    <ListItemText primary="Approval Status" />
                </ListItem>
                <ListItem button className="teacher-navbar-item"component={Link} to="/">
                    <ListItemIcon>
                        <Home className="teacher-navbar-icon" />
                    </ListItemIcon>
                    <ListItemText primary="Home" />
                </ListItem>
                <ListItem button className="teacher-navbar-item"component={Link} to="/manage-course">
                    <ListItemIcon>
                        <LibraryBooksIcon className="teacher-navbar-icon" />
                    </ListItemIcon>
                    <ListItemText primary="Manage-Course" />
                </ListItem>
                 {/* New Manage Students Navigation */}
                 <ListItem button className="teacher-navbar-item" component={Link} to="/manage-students">
                    <ListItemIcon>
                        <GroupIcon className="teacher-navbar-icon" />
                    </ListItemIcon>
                    <ListItemText primary="Manage Students" />
                </ListItem>

                  {/* ✅ CV Management visible only for TEACHER_MANAGER */}
                {roleNames?.includes("TEACHER_MANAGER") && (
                    <ListItem button className="teacher-navbar-item" component={Link} to="/cv-management">
                        <ListItemIcon>
                            <CheckCircleIcon className="teacher-navbar-icon" />
                        </ListItemIcon>
                        <ListItemText primary="CV Management" />
                    </ListItem>
                )}
                {/* ✅ Einstufungstest Management visible only for TEACHER_MANAGER */}
                {roleNames?.includes("TEACHER_MANAGER") && (
                <ListItem
                    button
                    className="teacher-navbar-item"
                    component={Link}
                    to="/manage-einstufungstest"
                >
                    <ListItemIcon>
                    <QuizIcon className="teacher-navbar-icon" />
                    </ListItemIcon>
                    <ListItemText primary="Placement Test" />
                </ListItem>
                )}

                {isManager && managerPermissions.viewCourseModeration && (
                    <ListItem button className="teacher-navbar-item" component={Link} to="/teacher-manager/course-moderation">
                        <ListItemIcon><RuleIcon className="teacher-navbar-icon" /></ListItemIcon>
                        <ListItemText primary="Course Moderation" />
                    </ListItem>
                )}

                {isManager && managerPermissions.viewCourseInterests && (
                    <ListItem button className="teacher-navbar-item" component={Link} to="/teacher-manager/course-interests">
                        <ListItemIcon><ContactMailIcon className="teacher-navbar-icon" /></ListItemIcon>
                        <ListItemText primary="Course Interests" />
                    </ListItem>
                )}

                {isManager && managerPermissions.viewPlacementAnalytics && (
                    <ListItem button className="teacher-navbar-item" component={Link} to="/manage-placement-results?tab=analytics">
                        <ListItemIcon><InsightsIcon className="teacher-navbar-icon" /></ListItemIcon>
                        <ListItemText primary="Placement Analytics" />
                    </ListItem>
                )}

                {roleNames?.includes("TEACHER_MANAGER") && (
                <ListItem
                    button
                    className="teacher-navbar-item"
                    component={Link}
                    to="/teacher-manager-courses"
                >
                    <ListItemIcon>
                    <CreateIcon className="teacher-navbar-icon" />
                    </ListItemIcon>
                    <ListItemText primary="Teacher Courses" />
                </ListItem>
                )}


                {roleNames?.includes("TEACHER_MANAGER") && (
                <ListItem
                    button
                    className="teacher-navbar-item"
                    component={Link}
                    to="/manage-placement-results"
                >
                    <ListItemIcon>
                    <QuizIcon className="teacher-navbar-icon" />
                    </ListItemIcon>
                    <ListItemText primary="Manage Placement Results" />
                </ListItem>
                )}




            </List>
        </Box>
    );
};

export default TeacherNavbar;
